import axios from '@/axios';
import jwt from '../../http/requests/auth/jwt';

export default {
  fetchProducts(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/store/products/list', { params: data })
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchStoreLimitation() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/store/products/limitation')
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchStoreBulkDiscount() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/store/products/discount')
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchStorePromo() {
    return axios.get('/api/v1/store/products/promo');
  },
  fetchClinicDiscounts(_context, clinicId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/clinics/discounts?clinicId=${clinicId}`)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchStoreFreeShipping() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/store/products/freeShipping')
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchCategories() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/store/products/fetchCategories')
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchPrimaryCategories() {
    return axios.get('/api/v1/store/products/fetchPrimaryCategories');
  },
  fetchSecondaryCategories() {
    return axios.get('/api/v1/store/products/fetchSecondaryCategories');
  },
  fetchSuppliers() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/store/products/fetchSuppliers')
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  deleteProductVariant(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/v1/store/products/${param.productId}/deleteVariant?variantId=${param.variantId}`
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  storeProduct(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/store/products/save', data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  findProductById(_context, pid) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/store/products?id=' + pid)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  removeProduct(_context, pid) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/store/products/${pid}/delete`)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateProduct(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/store/products/${param.id}/update`, param.data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateProductVariant(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `/api/v1/store/products/${param.id}/updateProductVariant`,
          param.data
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  addMoreProductImage(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/api/v1/store/products/${param.id}/addMoreProductImage`,
          { images: param.images, type: param.type }
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateProductImageStatus(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/api/v1/store/products/${param.id}/updateProductImageStatus`,
          param
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  duplicateProduct(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/api/v1/store/products/${param.id}/duplicate`,
          param
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateProductHideStatus(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .updateProductHttpHideStatus(data)
        .then((res) => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  },
  updateProductsOrderNumber(_context, data) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/v1/store/products/updateProductsOrder', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteProduct(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/v1/store/products/${id}/delete`,
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  addProductsToCategory(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/store/products/addProductsToCategory', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchProductsNotInCategory(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/store/products/notInCurrentCategory?search=' +
          data.search +
          '&categoryId=' +
          data.categoryId
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchProductsNotInBrand(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/store/products/notInCurrentBrand', { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addProductsToBrand(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/store/products/addProductsToBrand', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchProductTypes(){
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/store/products/getProductTypes')
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addBundledItems(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/store/products/addBundleItems', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchBundledItems(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/store/products/getBundledItems/${data.parentProductId}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateBundleItems(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/v1/store/products/updateBundledItems/${data.parentProductId}`, data.items)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteBundleItems(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/v1/store/products/deleteBundleItems/${data.parentProductId}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchEvolusProducts(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/store/products/filterEvolusProducts', {
            params: {
              id: data.id,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchSageDetails(_, sageItemId) {
    return axios.get(`/api/v1/store/products/sageDetails/${sageItemId}`);
  },
  uploadImages(_, {key, data}) {
    const config = {
      headers: {
        'Content-Type': 'image/png',
      },
    };
    return axios.post(`/api/v1/store/products/uploadImages?key=${key}`, data, config);
  },
  deleteImage(_, {imageId, imageUrl, productId, type}) {
    return axios.get(`/api/v1/store/products/deleteImage?imageId=${imageId}&imageUrl=${imageUrl}&productId=${productId}&type=${type}`);
  },
};
